<template>
    <v-col class="right-panel">
        <div v-if="current_task">
            <div class="task-body-wrap relative">
                <TTextArea class="task-body" :value="current_task.body" @input="setBody" rows="8" :key="current_task._id" @pasteFile="val => addFile(val)"/>
                <InputFileButton ref="select_file" class="select-file" accept="image/*" @change="addFile"/>
            </div>
            <Images :images="imagesForTask" @deleteImage="val  => deleteFile(val)"/>
            <RelatedElements class="ml-4" :element="current_task" :relatedElementsForTask="true"/>
            <div class="subs-container mt-6">
                <div v-if="$vuetify.breakpoint.smAndUp" class="subs-content ml-2" :class="{sm:$vuetify.breakpoint.sm}">
                    <v-col class="subs-body subs-body-md" md="6" ref="subBody" :class="{sm:$vuetify.breakpoint.sm}" :style="{overflowY: subsOverflow}">
                        <input
                            type="text"
                            class="input-subs"
                            required
                            placeholder="Введите заголовок"
                            v-model="subName"
                        >
                        <div class="divider"></div>
                        <SubBody :sub="picked_sub" v-if="current_task.subs.length && picked_sub" :key="picked_sub._id"/>
                        <TTextArea v-model="subBody" rows="6" v-else/>
                        <div class="subs_buttons">
                            <div class="right mr-10 mt-4">
                                <DeleteItem @deleteItem="deleteSub()" :sub="true" v-if="current_task.subs.length && picked_sub"/>
                            </div>
                            <div class="left ml-10 mt-4" v-if="picked_sub">
                                <div class="button_add_edit_sub pointer" @click="addSubHandle">Новая заметка</div>
                            </div>
                        </div>
                    </v-col>
                    <v-col md="6" ref="subsHeight" :style="{overflowY: subsOverflow}">
                        <v-row class="mt-n3">
                            <v-col class="flex-center-between subs-background">
                            <div class="add-sub flex-center pointer"  v-if="subs_plus">
                                <div class="roboto-normal-18 clr-black-38 pl-3">Заметки:</div>
                                <v-text-field
                                    class="ml-5"  
                                    v-if="current_task && current_task.subs.length"
                                    :prepend-icon="'mdi-magnify'"
                                    single-line
                                    clear-icon="mdi-close-circle"
                                    clearable
                                    type="text"
                                    v-model="subsSearch"
                                ></v-text-field>
                            </div>
                            <SwitchActive @toggle="toggleSubsAll" class="flex-center-between" :activeLength="subsActiveLength" :allLength="current_task && current_task.subs.length" :all="subsAll" v-show="current_task && current_task.subs.length"/>
                            </v-col>               
                        </v-row>
                        <v-row class="mb-n3 subs-height">
                            <div class="subs-background px-4 subs-grid w-100" :class="{md:$vuetify.breakpoint.mdAndDown}">
                                <div class="panel text-direction mb-7 mx-4" v-for="sub in filteredSubs" :key="sub._id">
                                <Sub
                                    :sub="sub"
                                    @click.native="pickedSub(sub)"
                                />
                                </div>
                            </div>
                        </v-row>
                    </v-col>
                </div>
            </div>
            <div class="relevant-notices" v-if="current_relevant_notices && current_relevant_notices.length">
                <v-col cols="6" class="flex-center-between">
                    <div class="add-sub flex-center pointer">
                        <div class="roboto-normal-18 clr-black-38 pl-3">Заметки из ленты:</div>
                    </div>
                    <div class="roboto-normal-18 clr-black-9d pointer" @click="toggleRelevantNoticesAll">
                        <img v-if="!relevantNoticesAll" class="right mt-n1" height="29px" src="@/assets/images/components/arrow-up.svg">
                        <img v-if="relevantNoticesAll"  class="right mt-n1" height="29px" src="@/assets/images/components/arrow-down.svg">
                        <div v-if="relevantNoticesAll" class="right ml-11 mr-4">Активные ({{relevantNoticesActiveLength}})</div>
                        <div v-else class="right ml-11 mr-4">Все ({{current_task && current_relevant_notices.length}})</div>
                        <div class="right mr-4" v-show="$vuetify.breakpoint.xlOnly">Показать:</div>
                    </div>
                </v-col>
                <v-row class="mx-1">
                    <v-col cols="6" sm="6" lg="3" v-for="(notice, i) in relevantNotices" :key="i">
                        <ItemCard :search="true" :notice="notice"/>
                    </v-col>
                </v-row>
            </div>     
        </div>
    </v-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {debounce, sortBy} from 'lodash'
import TTextArea from '../../misc/TTextArea'
import Images from '../../popups/Images'
import RelatedElements from '../RelatedElements/RelatedElements'
import SubBody from '../SubBody'
import Sub from '../Sub'
import {relevantNotices, searchNotices, imagesOfItems} from '../../../helpers'
import DeleteItem from '../../popups/DeleteItem'
import InputFileButton from '@/components/misc/InputFileButton.vue'
import ItemCard from '../ItemCard.vue'
import SwitchActive from './SwitchActive.vue'
export default {
    name: 'RightPanel',
    components:{
        TTextArea,
        Images,
        RelatedElements,
        SubBody,
        Sub,
        DeleteItem,
        InputFileButton,
        ItemCard,
        SwitchActive,
    },
    data() {
        return {
            subs_plus: true,
            subs_plus_name: '',
            subsSearch: '',
            subsAll: false,
            relevantNoticesAll: false,
            subsOverflow: 'hidden'
        }
    },
    computed:{
        ...mapGetters(["current" , "current_task", "feeds", "current_relevant_notices", "picked_sub"]),
        tasks() {
            const tasks = this.current ? this.current.tasks : []
            const filterTasks = this.tasksSearch ? tasks.filter(el => el.name.toLowerCase().includes(this.tasksSearch.toLowerCase())) : tasks
            return this.all ? tasks && filterTasks : tasks.filter(el => !el.completed && !this.current.groups.some(group => group.itemsId.some(id => id == el._id)) && !el.elder) 
        },
        imagesForTask() {
            const parsingLinks = imagesOfItems(this.current_task)
            const set = imagesOfItems(this.current_task) && [...(this.current_task.blockedLinks || [])] && new Set(this.current_task.blockedLinks)
            const links = parsingLinks.filter(e => !set.has(e))
            const taskImages = this.current_task.images && this.current_task.images.map((el) => this.$root.origin + '/api' + el)
            return [...(taskImages || []), ...links]
        },
        subs() {
            const subs = this.current_task ? this.current_task.subs : []
            const unsorted = this.subsAll ? subs : subs.filter(el => !el.completed && !el.elder)
            return sortBy([...unsorted], a => new Date(a.updatedAt)).reverse()
        },
        subsActiveLength() {
            return this.subs && this.subs.filter(el => !el.completed && !el.elder).length
        },
        filteredSubs() {
            return this.subsSearch ? this.subs.filter((el, i) => el.name.toLowerCase().includes(this.subsSearch.toLowerCase())) : this.subs
        },
        relevantNotices() {
            const relevantNotices = this.current_task ? this.current_relevant_notices : []
            const unsorted = this.relevantNoticesAll ? relevantNotices : relevantNotices.filter(el =>  !~el.completedInTasks.indexOf(this.current_task._id))
            return unsorted.sort((a,b) => +new Date(a.createdAt) < +new Date(b.createdAt) ? 1 : -1)
        },
        relevantNoticesActiveLength() {
            return this.relevantNotices && this.relevantNotices.filter(el => !~el.completedInTasks.indexOf(this.current_task._id)).length
        },
        subName: {
            get() {
                return this.picked_sub ? this.picked_sub.name : ""
            },
            set: debounce (async function(newVal) {
                    if (this.picked_sub) {
                        this.renameSub({
                            _id: this.current._id, 
                            task_id: this.current_task._id, 
                            sub_id: this.picked_sub._id, 
                            name: newVal
                        })
                    } else {
                        await this.addSub ({
                            theme_id: this.current._id, 
                            task_id: this.current_task._id,
                            sub:{name: newVal, body: ""}
                        })
                        await this.pickedSub(this.current_task.subs[this.current_task.subs.length - 1])
                    }
            },1000)
        },
        subBody:{
            get(){
              return this.picked_sub ? this.picked_sub.body : ""
            },
            set: debounce(async function(newVal) {
                if (newVal.split(' ').length-1 > 4) {
                    await this.addSub ({
                        theme_id: this.current._id, 
                        task_id: this.current_task._id,
                        sub:{name: newVal.replace(/<\/?[a-zA-Z]+>/gi,''), body: ""}
                    })
                    await this.editSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.current_task.subs[this.current_task.subs.length - 1]._id, text: newVal})
                    await this.pickedSub(this.current_task.subs[this.current_task.subs.length - 1])
                }
            }, 450)
        },
    },
    methods:{
        ...mapActions(["addSub", "editTask", "renameSub", "editSub", "delSub", "uploadFiles", "setImagesToTask", "setBlockedLinksToTask"]),
        ...mapMutations(["TOGGLE_PICKED_SUB"]),
        setBody: debounce(function(newVal) {
            this.editTask({_id: this.current._id, task_id: this.current_task._id, text: newVal})
        }, 450),
        subsRenameOk(){
            this.subs_plus_name
            this.subs_plus = true
            this.subs_plus_name = ''
        },
        async addSubHandle() {
            // const sub = await this.addSub({theme_id: this.current._id, task_id: this.current_task._id, sub:{name: this.subs_plus_name, body: ""}})
            this.pickedSub(this.picked_sub)
        },
        toggleSubsAll() {
            this.subsAll = !this.subsAll
        },
        pickedSub(sub) {
            const relNotices = relevantNotices(this.feeds, this.current_task)
            const relNoticesForSub = []
            searchNotices(relNotices, sub, relNoticesForSub)
            this.TOGGLE_PICKED_SUB({sub, relNotices, relNoticesForSub})
            // const elementSub = document.getElementById(`sub-id-${sub._id}`)
            // const elementSubScroll = elementSub.getBoundingClientRect()
            // if(elementSubScroll.height > 68) {
            //   this.$vuetify.goTo(`#sub-id-${sub._id}`, {offset: elementSubScroll.top - 64})
            // } 
        },
        toggleRelevantNoticesAll() {
            this.relevantNoticesAll = !this.relevantNoticesAll
        },
        async deleteSub() {
            if (this.picked_sub) {
                await this.delSub({theme_id: this.current._id, task_id: this.current_task._id, sub_id: this.picked_sub._id})
                await this.pickedSub(this.picked_sub)
            }
        },
        async addFile(e) {
            const file = (e.target && e.target.files[0]) || e
            if (file) {                    
                const formData = new FormData()
                formData.append('file', file)
                const filesRes = await this.uploadFiles(formData)
                await this.setImagesToTask({_id: this.current._id, task_id: this.current_task._id, images: [...(this.current_task.images || []), ...filesRes.map((el) => el.path)]})
            }
        },
        async deleteFile(e) {
            if (e.includes(this.$root.origin + "/api")) {
                this.current_task.images.splice(this.current_task.images.findIndex(image => image == e.slice(24)),1)
                await this.setImagesToTask({_id: this.current._id, task_id: this.current_task._id, images: [...(this.current_task.images || [])]})
            } else {
                this.current_task.blockedLinks.push(e)
                await this.setBlockedLinksToTask({_id: this.current._id, task_id: this.current_task._id, blockedLinks: [...(this.current_task.blockedLinks || [])]})
            }
        },
        scrollOverflowHandler() {
            if (this.$refs.subsHeight && (this.$refs.subsHeight.getBoundingClientRect().bottom - 30) < window.outerHeight) {
                this.subsOverflow = 'auto'
            }
        }
    },
    watch: {
        current_task() {
            this.subsOverflow = 'hidden'
        }
    }, 
}
</script>

<style lang="scss" scoped>
    .subs-body-md{
        height: 600px;
        overflow-x: hidden;
    }
    .select-file{
        position: absolute;
        bottom: 0;
        right: 20px;
    }
    .divider{
        width: calc(100% - 30px);
        border-bottom: 1px solid lightgray;
        margin: auto;
    }
.right-panel {
    width: calc(100% - 287px);
    height: calc(100vh - 94px);
    overflow-y: scroll;
    overflow-x: hidden;
    .task-body{
        //padding: 15px 40px;
        background: var(--cl-secondary);
        .v-input__slot{
            border-radius: 0;
        }    
    }
    .subs-container {
        .subs-content {
            display: flex;
            flex-direction: row-reverse;
            &.sm {
                display: block;
            }
        }
        .subs-height {
            max-height: 600px;
            overflow-x: hidden;
            overflow-y: auto;
        }
        .subs-height::-webkit-scrollbar {
            width: 9px;
            background-color: #FAFAFA;
        }
        ::-webkit-scrollbar-thumb {
            background-color: #EDEDED;
        }
        .subs-background {
            background:rgba(253, 253, 253, 1)
        }
        .subs-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            &.md {
                grid-template-columns: repeat(1, 100%);
            }
        }
        .subs-body {
            .save-sub {
                justify-content: flex-end;
                align-items: center;
            }
            &.sm {
                height: auto;
            }
        }
    }
    .relevant-notices {
        margin-top:20px;
        position: relative;
    }
}
</style>

<style lang="scss">
.subs-container {
    .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
        border-color: rgba(0,0,0,.02);
    }
}
.right-panel{
    .task-body-wrap{
        .t-textarea {
            max-height: 350px;
            overflow-y: scroll;
        }
    }
}
</style>